import { useEffect, useMemo, useRef } from "react";
import { debounce } from "lodash";
export const DEBOUNCE_TIMER = 300;
function isDebouncedFunc(func) {
    return func.cancel !== undefined;
}
function useDebounce(data, timer = DEBOUNCE_TIMER, callback) {
    const savedCallback = useRef(callback);
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    const onChange = useMemo(() => {
        const handler = (newData) => savedCallback.current(newData);
        return timer > 0 ? debounce(handler, timer) : handler;
    }, [timer]);
    useEffect(() => {
        onChange(data);
        return () => {
            if (isDebouncedFunc(onChange))
                onChange.cancel();
        };
    }, [data, onChange]);
}
export default useDebounce;
//# sourceMappingURL=useDebounce.js.map